import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';

import { useCallStore } from '@/stores/call.store';

import { useElapsed } from '@/features/calls/hooks/useElapsed';

/**
 * La pastille « appel en cours », posée au-dessus du site tant qu'un appel
 * dure et que son écran est refermé : on écrit dans la discussion, on
 * consulte une fiche, et l'appel est toujours là, à un clic.
 */
export function OngoingCallPill() {
  const { t } = useTranslation('calls');
  const { pathname } = useLocation();
  const phase = useCallStore((state) => state.phase);
  const connectedAt = useCallStore((state) => state.connectedAt);
  const elapsed = useElapsed(phase === 'active' ? connectedAt : null);

  const live = phase === 'outgoing' || phase === 'connecting' || phase === 'active';
  if (!live || pathname.startsWith('/call')) {
    return null;
  }

  return (
    <Link
      to="/call"
      aria-label={t('banner.back')}
      className="fixed top-[calc(env(safe-area-inset-top)+64px)] left-1/2 z-40 inline-flex min-h-8 -translate-x-1/2 items-center gap-2 rounded-pill bg-call-stage px-3.5 text-caption font-medium text-stage-fg tabular-nums shadow-floating hover:opacity-90"
    >
      <span aria-hidden className="size-2 rounded-pill bg-success" />
      {elapsed ? `${t('banner.label')} · ${elapsed}` : t('banner.label')}
    </Link>
  );
}
